export default __webpack_public_path__ + "static/media/approval_icon.02f0b88a.svg";